import script from "./SecuritySettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SecuritySettings.vue?vue&type=script&setup=true&lang=js"

import "./SecuritySettings.vue?vue&type=style&index=0&id=9dbac9c0&scoped=true&lang=css"

import exportComponent from "../../../consumer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dbac9c0"]])

export default __exports__